// src/services/api.js
import axios from 'axios';

const api = axios.create({
  baseURL: 'https://gate.eaes.et', // The URL of your running backend
});

// This is a "request interceptor". It runs before every single API request.
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      // If a token exists, add it to the Authorization header
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // If there's an error setting up the request, reject the promise
    return Promise.reject(error);
  }
);

export default api;